import { PrefillSkdp } from "@/types/resumeRalanBlanko";

let titipan: { register: string; prefill: PrefillSkdp } | null = null;

export function titipPrefillSkdp(
  register: string | number,
  prefill: PrefillSkdp
): void {
  titipan = { register: String(register), prefill };
}

export function ambilPrefillSkdp(
  register: string | number
): PrefillSkdp | null {
  if (!titipan || titipan.register !== String(register)) {
    return null;
  }

  const prefill = titipan.prefill;
  titipan = null;

  return prefill;
}
